import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientDashboardState } from 'src/app/client-dashboard/state/client-dashboard.state';
import { ProspektrApi } from '../api/prospektr.api';

@Injectable({
  providedIn: 'root',
})
export class ListingService {
  constructor(private prospektrApi: ProspektrApi, private clientDashboardState: ClientDashboardState) { }

  updateExpiredListings(params) {
    return new Observable((observer) => {
      observer.next({ isLoading: true });

      this.prospektrApi.updateExpiredListingsForAgent(params).subscribe(
        (res: any) => {
          if (!res) return;

          observer.next({
            isLoading: false,
            data: res,
          });

          observer.complete();
        },
        (err) => observer.error(err)
      );
    });
  }


  fetchAgentListings(params) {
    return new Observable((observer) => {
      observer.next({ isLoading: true });

      this.prospektrApi.fetchAgentListings(params).subscribe(
        (res: any) => {
          if (!res) return;

          observer.next({
            isLoading: false,
            data: res,
          });

          observer.complete();
        },
        (err) => observer.error(err)
      );
    });
  }

  fetchExpiredListings(params) {
    return new Observable((observer) => {
      this.prospektrApi.fetchExpiredListingsForAgent(params).subscribe(
        (res: any) => {
          if (!res) {
            observer.complete();
            return;
          }
          this.clientDashboardState.expiredListInfoValue = res || [];
          observer.next({
            isLoading: false,
            data: res,
          });

          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  // fetchExpiredListings(params) {
  //   return new Observable((observer) => {
  //     this.prospektrApi.fetchExpiredListingsForAgent(params).subscribe(
  //       (res: any) => {
  //         if (!res) return;
  //         console.log(res, 'res');
  //         this.clientDashboardState.expiredListInfoValue = res.data?.result || [];

  //         observer.next({
  //           isLoading: false,
  //           data: res,
  //         });

  //         observer.complete();
  //       },
  //       (err) => observer.error(err)
  //     );
  //   });
  // }

  updateExpiredListingsOwnerData(params, source?) {
    return new Observable((observer) => {
      this.prospektrApi.updateExpiredListingsOwnerData(params).subscribe(
        (res: any) => {
          if (!res) return;
          observer.next({
            isLoading: false,
            data: res,
          });
          if (source === 'mail') {
            this.clientDashboardState.expiredListInfoValue = this.clientDashboardState.expiredListInfoValue.map(
              (listing) => {
                if (listing.ListingId === params.ListingId) {
                  return {
                    ...listing,
                    ownerName: params.ownerName,
                    ownerEmail: params.ownerEmail,
                  };
                }
                return listing;
              }
            );
          }
          observer.complete();
        },
        (err) => observer.error(err)
      );
    });
  }
}
